import * as React from "react";
function SvgIcConfirm(props) {
  return <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 3.5l-7 7-3-3" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></svg>;
}
export default SvgIcConfirm;